export const TEST_ID = 'heroTitleText';
